import { Controller } from 'stimulus';
import { useResizeObserver } from '@/js/util';

const FADE_START_CLASS = 'thumbnail-strip__list--fade-start';
const FADE_END_CLASS = 'thumbnail-strip__list--fade-end';

export default class extends Controller {
  static targets = ['list', 'current'];

  connect() {
    this.revealCurrent();
    this.updateFade();
    useResizeObserver(this);
    this.createResizeObserver(() => this.updateFade()).observe(this.listTarget);
  }

  // Scrolls the list horizontally only: scrollIntoView() would also scroll the page to the strip.
  // The list is positioned, so offsetLeft is measured from its padding edge.
  revealCurrent() {
    if (!this.hasCurrentTarget) {
      return;
    }

    const list = this.listTarget;
    const current = this.currentTarget;
    if (current.offsetLeft + current.offsetWidth > list.clientWidth) {
      list.scrollLeft = current.offsetLeft - (list.clientWidth - current.offsetWidth) / 2;
    }
  }

  // Fades an edge only while designs are hidden past it.
  updateFade() {
    const { scrollLeft, scrollWidth, clientWidth } = this.listTarget;
    // 1px of slack: scrollLeft is fractional on zoomed or high-DPI screens.
    this.listTarget.classList.toggle(FADE_START_CLASS, scrollLeft > 1);
    this.listTarget.classList.toggle(FADE_END_CLASS, scrollLeft + clientWidth < scrollWidth - 1);
  }
}
